/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Scores_SubmittedInputs */

const fr_no_scores_submitted = /** @type {(inputs: No_Scores_SubmittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun score soumis pour le moment`)
};

/**

* @param {No_Scores_SubmittedInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const no_scores_submitted = /** @type {((inputs?: No_Scores_SubmittedInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Scores_SubmittedInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_no_scores_submitted(inputs)
});